import {
  DragDropProvider,
  DragHandle,
  DropTarget,
} from '@wandb/weave/common/containers/DragDropContainer';
import React from 'react';

import {ReorderFn, useDragDropReorder} from '../../util/dragDrop';
import {ShowcasedProject} from './context';
import * as S from './ProjectShowcaseCards.styles';

const ITEM_DROPZONE_PADDING_PX = 8;

type ProjectShowcaseCardsProps = {
  items: ShowcasedProject[];
  reorderItems: ReorderFn;
  readOnly: boolean;
};

export const ProjectShowcaseCards: React.FC<ProjectShowcaseCardsProps> =
  React.memo(({items, reorderItems, readOnly}) => {
    const {
      makeDragSourceCallbackRef,
      renderDropIndicators,
      onDragOver,
      onDragEnd,
      onDrop,
    } = useDragDropReorder({
      reorder: reorderItems,
      dropzonePadding: ITEM_DROPZONE_PADDING_PX,
    });

    return (
      <DragDropProvider>
        <DropTarget
          partRef={{id: `target`}}
          onDragOver={onDragOver}
          onDrop={onDrop}>
          <S.Grid>
            {items.map(({id, url, name, user, lastRun, runCount}, i) => (
              <S.Card key={id} to={url} ref={makeDragSourceCallbackRef(i)}>
                <S.CardContent
                  partRef={{id: `${i}`}}
                  draggingStyle={{opacity: 0.25}}
                  onDragEnd={onDragEnd}>
                  {renderDropIndicators(i)}
                  <S.CardText>
                    <S.CardHeader>{name}</S.CardHeader>
                    <S.CardUser>
                      <S.UserIcon /> <S.ClampedLine>{user}</S.ClampedLine>
                    </S.CardUser>
                    <S.CardMeta>
                      <S.CardMetaLeft>
                        <S.RunsIcon />{' '}
                        <S.ClampedLine>{runCount} runs</S.ClampedLine>
                      </S.CardMetaLeft>
                      <S.CardMetaRight>
                        <S.UpdatedAtIcon />{' '}
                        <S.ClampedLine>Last run {lastRun}</S.ClampedLine>
                      </S.CardMetaRight>
                    </S.CardMeta>
                  </S.CardText>
                  {!readOnly && (
                    <S.CardActions>
                      <DragHandle partRef={{id: `${i}`}}>
                        <S.DragHandle />
                      </DragHandle>
                    </S.CardActions>
                  )}
                </S.CardContent>
              </S.Card>
            ))}
          </S.Grid>
        </DropTarget>
      </DragDropProvider>
    );
  });
